export default __webpack_public_path__ + "static/media/b_dashboard.4274f858.png";